import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Configuration, OpenAIApi } from 'openai';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Ai = () => {
  const [numPages, setNumPages] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [openAiResults, setOpenAiResults] = useState([]);

  useEffect(() => {
    if (openAiResults.length > 0) {
      const combinedJsonResult = `{${openAiResults.join(',')}}`;
      console.log('Combined JSON Result:', combinedJsonResult);
    }
  }, [openAiResults]);

  const extractTextFromPage = async (page) => {
    const textContent = await page.getTextContent();
    const pageText = textContent.items.map((item) => item.str).join(' ');
    return pageText;
  };

  const processTextChunks = async (textChunks, openai) => {
    const promises = textChunks.map(async (chunk) => {
      const combinedText_ = `CV Text:\n${chunk} rewrite as json file with following format
       `;
      const response = await openai.createCompletion({
        model: 'text-davinci-003',
        prompt: combinedText_,
        temperature: 0.7,
        max_tokens: 2000, // Adjust as needed
      });
      return response.data.choices[0].text;
    });
    const responses = await Promise.all(promises);
    setOpenAiResults(responses);
  };

  const onDocumentLoadSuccess = async ({ numPages }) => {
    setNumPages(numPages);

    try {
      const textPromises = [];
      for (let i = 1; i <= numPages; i++) {
        const pdf = await pdfjs.getDocument({ url: selectedPdf }).promise;
        const page = await pdf.getPage(i);
        textPromises.push(extractTextFromPage(page));
      }

      const pageTexts = await Promise.all(textPromises);
      const combinedText = pageTexts.join(' ');

      const chunks = [];
      let startIndex = 0;
      while (startIndex < combinedText.length) {
        chunks.push(combinedText.substring(startIndex, startIndex + 4000));
        startIndex += 4000;
      }

      const configuration = new Configuration({
        apiKey: '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', // Replace with your OpenAI API key
      });
      const openai = new OpenAIApi(configuration);

      await processTextChunks(chunks, openai);
    } catch (error) {
      console.error('Failed to extract PDF text or call OpenAI:', error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedPdf(URL.createObjectURL(file));
  };

  return (
    <div>
      <input type="file" accept=".pdf" onChange={handleFileChange} />
      <div style={{display:'none'}}>      <Document file={selectedPdf} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
     </div>
      <div>
        <h2>OpenAI Results:</h2>
        <pre>
          {openAiResults.map((result, index) => (
            <div key={`result_${index}`}>{result}</div>
          ))}
        </pre>
      </div>
    </div>
  );
};

export default Ai;
